import { createTheme } from '@mui/material/styles';
import './ThemeTypes';

const PvwineTheme = createTheme({
    palette: {
        common: {
            black: "#272727"
        },
        primary: {
            main: "#b15aae",
            light: "#f2a023",
            dark: "#2596be"
        },
        secondary: {
            main: "#00611f",
            light: "#2596be",
            dark: "#016f5fff"
        },
        surface: {
            main: "#ffffffff",
        }
    },
});

export default PvwineTheme;
